module.exports = __webpack_public_path__ + "static/media/oil-temp.01d80d6e.svg";